const TimeoutDirective = function () {
    return {
        restrict: 'E',
        scope: { left: '@left' },
        template: '<span class="countdown">{{remainder}}</span>',

        controller: function ($scope, $http) {
            if ($scope.left) {
                var expiryDate = new Date();
                var timeLeft = $scope.left || 0;

                // setting the expiry date
                if (timeLeft !== 0) {
                    var tmp = timeLeft.split(':');
                    var seconds = (+tmp[ 0 ]) * 60 * 60 + (+tmp[ 1 ]) * 60 + (+tmp[ 2 ]);
                    expiryDate.setSeconds(expiryDate.getSeconds() + seconds);
                    expiryDate.setHours(expiryDate.getHours() - 1);
                } else {
                    if (typeof ga !== "undefined") {
                        // Tracking 2a: Basket gets a timeout for reservation time which is equally to remainder - 0
                        ga('set', 'page', 'newCO_emptyBasket_timeout');
                        ga('send', 'pageview');
                    }
                }

                $scope.remainder = getRemainderString(getTimeRemaining(expiryDate));

                var timer = setInterval(function () {
                    var remainderObject = getTimeRemaining(expiryDate);
                    if (remainderObject.total > 0) {
                        $scope.remainder = getRemainderString(remainderObject);
                        $scope.$apply();
                    } else {
                        clearInterval(timer);
                        if (typeof amazon !== 'undefined' && typeof amazonPay !== 'undefined') {
                            amazonPay.triggerLogout(true);
                        }
                        $http.get('/app.php?view=purchase')
                            .then(function () {
                                location.href = '/app.php?view=purchase';
                            });
                    }
                }, 1000);
            }

            function getRemainderString(remainderObject) {
                var remainder = remainderObject.minutes + ':' + remainderObject.seconds;
                if (remainderObject.hours !== '00') {
                    remainder = remainderObject.hours + ':' + remainder;
                }
                return remainder;
            }

            function getTimeRemaining(endtime) {
                var t = Date.parse(endtime) - new Date();
                var seconds = Math.floor((t / 1000) % 60);
                var minutes = Math.floor((t / 1000 / 60) % 60);
                var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
                var days = Math.floor(t / (1000 * 60 * 60 * 24));
                //var minutes =+ hours*60; // See "5bc9f84" - i am not sure about this double declaration
                return {
                    'total': t,
                    'days': ("0" + days).slice(-2),
                    'hours': ("0" + hours).slice(-2),
                    'minutes': ("0" + minutes).slice(-2),
                    'seconds': ("0" + seconds).slice(-2)
                };
            }
        }
    };
};

export default TimeoutDirective;
